import { registryLabel } from '@/types/stats/registryLabel.ts';

/** Odbicia i odpływy obok głównej ścieżki lejka. Wszystkie jako `COUNT`. */
export enum FunnelMetricKey {
  OFFER_VIEWED_NOT_OPEN = 'OFFER_VIEWED_NOT_OPEN',
  OFFER_VIEWED_CLOSED = 'OFFER_VIEWED_CLOSED',
  OFFER_VIEWED_SOLD_OUT = 'OFFER_VIEWED_SOLD_OUT',
  WAITLIST_VIEWED = 'WAITLIST_VIEWED',
  WAITLIST_JOINED = 'WAITLIST_JOINED',
  CANCELLED = 'CANCELLED',
  WITHDRAWN = 'WITHDRAWN',
}

export const FUNNEL_METRIC_LABELS: Record<FunnelMetricKey, string> = {
  [FunnelMetricKey.OFFER_VIEWED_NOT_OPEN]: 'Wejścia przed otwarciem zapisów',
  [FunnelMetricKey.OFFER_VIEWED_CLOSED]: 'Wejścia po zamknięciu zapisów',
  [FunnelMetricKey.OFFER_VIEWED_SOLD_OUT]: 'Wejścia przy komplecie',
  [FunnelMetricKey.WAITLIST_VIEWED]: 'Wejścia na listę rezerwową',
  [FunnelMetricKey.WAITLIST_JOINED]: 'Zapisy na listę rezerwową',
  [FunnelMetricKey.CANCELLED]: 'Anulowane rezerwacje',
  [FunnelMetricKey.WITHDRAWN]: 'Rezygnacje uczestników',
};

export const funnelMetricLabel = (key: string): string =>
  registryLabel(FUNNEL_METRIC_LABELS, key, 'metryka lejka');
